import React, { Component } from 'react';


class AboutMe extends Component {
  render() {
    return(
      <div><h5>A hard working, a passionate about Problem solving and full stack development with immense interest in Algorithms and Data Structures. A firm believer of the quote :“Take risks now and do something bold. You won’t regret it.”― Elon Musk </h5></div>
    )
  }
}

export default AboutMe;